import { ChatbotApi } from 'entities/Chatbot'
import { checkUsageAgent } from 'features/ItemUsage/actions/checkUsageAgent.tsx'
import { InboxesPath } from 'pages/settings/pages/inboxes/route/inboxesPath'

export const checkUsage = async (id: number, action: 'disable' | 'delete') => {
  const { data } = await ChatbotApi.getAgentUsage(id)
  return checkUsageAgent({
    data,
    action,
    getLink: (inbox) =>
      inbox.source === 'workflow'
        ? InboxesPath.inboxSmartCallFlow(inbox.team_id)
        : InboxesPath.inboxAiAutomation(inbox.team_id),
  })
}
